export const onInitialClientRender = () => {
  if (process.env.BUILD_STAGE === 'develop') return;

  // Remove the server-side injected CSS.
  const css = document.querySelector('#jss-server-side');
  if (css) {
    css.parentNode.removeChild(css);
  }
};
